<!-- eslint-disable -->
<template lang="pug">
    table.playground
        tr(v-for="(elements, rowIndex) in gameItems")
            td.memory-item(v-for="(item, columnIndex) in elements" @click="$emit('selectItem', item, rowIndex, columnIndex)")
                img.game-item.game-item_hidden(:src="item.value | apiFile")
                span.memory-item__number(:class="{'memory-item__number_big': shirtNumbers[rowIndex][columnIndex] > 9}") {{ shirtNumbers[rowIndex][columnIndex] }}
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            gameItems: Array,
            amountOfColumns: Number,
        },
        mounted () {
            let cells = document.querySelectorAll('.memory-item');
            if (cells && cells.length) {
                if (this.amountOfColumns === 4) {
                    cells.forEach(cell => {
                        cell.classList.add('memory-item_small');
                    });
                }
                if (this.amountOfColumns === 5) {
                    cells.forEach(cell => {
                        cell.classList.add('memory-item_x-small');
                    });
                }
                if (this.gameItems.length === 5) {
                    cells.forEach(cell => {
                        cell.classList.add('memory-item_tiny');
                    });
                    return;
                }
                if (this.gameItems.length === 6 || this.amountOfColumns === 6) {
                    cells.forEach(cell => {
                        cell.classList.add('memory-item_x-tiny');
                    });
                }
            }
        },
        computed: {
            shirtNumbers () {
                let numbers = [];
                let counter = 0;
                for (let i = 0; i < this.gameItems.length; i++) {
                    for (let j = 0; j < this.amountOfColumns; j++) {
                        counter += 1;
                        numbers.push([]);
                        numbers[i][j] = counter;
                    }
                }
                return numbers;
            }
        }
    }
</script>

<style scoped lang="scss">
    .playground {
        width: auto;
        border-collapse: separate;
        border-spacing: 10px;
        border-radius: 10px;
        table-layout: fixed;
        background: #FFFFFF;
        @media screen and (max-width: 1199px) {
            border-spacing: 5px;
        }
    }
    .memory-item {
        border: 2px solid #FFFFFF;
        border-radius: 10px;
        cursor: pointer;
        user-select: none;
        transition: all .5s ease;
        transform: rotateY(-180deg);
        background: url("../../../../assets/images/card-background.png") #6BBD6C;
        background-size: cover;
        width: 150px;
        max-width: 200px;
        height: 150px;
        max-height: 200px;
        overflow: hidden;
        @media screen and (max-width: 1199px) {
            width: 110px;
            height: 110px;
        }
        img {
            display: block;
            width: 150px;
            max-width: 200px;
            height: 150px;
            max-height: 200px;
            @media screen and (max-width: 1199px) {
                width: 110px;
                height: 110px;
            }
        }
        &_disabled {
            pointer-events: none;
        }
        &_selected {
            background-image: none;
            border: 2px solid #6BBD6C;
            transform: rotateY(0);
        }
        &_correct {
            background-image: none;
            pointer-events: none;
            border: 2px solid #6BBD6C;
            transform: rotateY(0);
        }
        &_before-game-started {
            border: none;
        }
        &_small {
            @media screen and (max-width: 1199px) {
                width: 110px;
                height: 110px;
            }
            img {
                @media screen and (max-width: 1199px) {
                    width: 110px;
                    height: 110px;
                }
            }
            .memory-item__number {
                @media screen and (max-width: 1199px) {
                    font-size: 48px;
                    line-height: 60px;
                    &_big {
                        left: 30%;
                    }
                }
            }
        }
        &_x-small {
            @media screen and (max-width: 1199px) {
                width: 110px;
                height: 110px;
            }
            @media screen and (max-width: 991px) {
                width: 105px;
                height: 105px;
            }
            img {
                @media screen and (max-width: 1199px) {
                    width: 110px;
                    height: 110px;
                }
                @media screen and (max-width: 991px) {
                    width: 105px;
                    height: 105px;
                }
            }
            .memory-item__number {
                @media screen and (max-width: 1199px) {
                    font-size: 48px;
                    line-height: 60px;
                    &_big {
                        left: 30%;
                    }
                }
                @media screen and (max-width: 991px) {
                    font-size: 46px;
                    line-height: 63px;
                    &_big {
                        left: 25%;
                    }
                }
            }
        }
        &_tiny {
            width: 120px;
            height: 120px;
            @media screen and (max-width: 1199px) {
                width: 90px;
                height: 90px;
            }
            @media screen and (max-width: 991px) {
                width: 87px;
                height: 87px;
            }
            img {
                width: 120px;
                height: 120px;
                @media screen and (max-width: 1199px) {
                    width: 90px;
                    height: 90px;
                }
                @media screen and (max-width: 991px) {
                    width: 87px;
                    height: 87px;
                }
            }
            .memory-item__number {
                font-size: 52px;
                line-height: 62px;
                top: 25%;
                @media screen and (max-width: 1199px) {
                    font-size: 40px;
                    line-height: 50px;
                    &_big {
                        left: 30%;
                    }
                }
                @media screen and (max-width: 991px) {
                    font-size: 30px;
                    line-height: 43px;
                }
            }
        }
        &_x-tiny {
            width: 96px;
            height: 96px;
            @media screen and (max-width: 1199px) and (min-width: 991px) {
                width: 70px;
                height: 70px;
            }
            @media screen and (max-width: 991px) {
                width: 80px;
                height: 80px;
            }
            img {
                width: 96px;
                height: 96px;
                @media screen and (max-width: 1199px) and (min-width: 991px) {
                    width: 70px;
                    height: 70px;
                }
                @media screen and (max-width: 991px) {
                    width: 80px;
                    height: 80px;
                }
            }
            .memory-item__number {
                font-size: 52px;
                line-height: 62px;
                top: 20%;
                &_big {
                    left: 20%;
                }
                @media screen and (max-width: 1199px) {
                    font-size: 40px;
                    line-height: 43px;
                    &_big {
                        left: 15%;
                    }
                }
             }
        }
        &__number {
            transform: rotateY(180deg);
            font-weight: 500;
            font-size: 62px;
            line-height: 73px;
            text-align: center;
            color: #FFFFFF;
            position: absolute;
            top: 30%;
            left: 35%;
            @media screen and (max-width: 1199px) {
                top: 20%;
            }
            &_big {
                left: 30%;
            }
            &_hidden {
                visibility: hidden;
            }
        }
    }
    .game-item_hidden {
        visibility: hidden;
    }
    td:empty {
        visibility: hidden;
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
